import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SnackbarService } from '../services/snackbar/snackbar.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private snackbarService: SnackbarService
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.checkSession().pipe(
      map((user) => {
        if (user) {
          return true;
        } else {
          return false;
        }
      }),
      catchError((err) => {
        // If backend says not logged in
        // Show error message, could be important if a user tries to
        // login with a switch account connencted to an email-address
        // Which has already been used for a jwt-registration
        const errorMessage = this.handleOidcError(err);
        this.snackbarService.showErrorMessage(errorMessage);

        // Clear session in backend, this is important
        // to avoid possible conflicts if the user tries to login again
        this.authService.logout();

        return of(false);
      })
    );
  }

  private handleOidcError(error: any): string {
    let errorMessage = '';

    if (
      error.error &&
      error.error.message &&
      error.error.message.includes('email already exists')
    ) {
      errorMessage =
        'The email linked to your switch-Login account seems to be already registered. Change the email-Adress of your already existing Account or contact support.';
    } else if (error.error && error.error.message) {
      errorMessage = error.error.message;
    } else {
      errorMessage = 'Authentication failed. Please try again.';
    }
    return errorMessage;
  }
}
